import { TFunction } from 'i18next';
import { SearchListItem } from '../types';
import { ResourcePage, SearchType } from 'src/graphql/generated/graphql';
import { DataTableMeta, LimitedContent } from '@otp/ui';
import { TypeColumn } from './columns/type';
import { LinkColumn } from './columns/link';
import { ItemColumn } from './columns/item';
import { HighlightColumn } from './columns/highlight';

export const getTableConfig = (
  data: Partial<SearchListItem>[],
  { t }: { t: TFunction },
) => [
  {
    name: 'item',
    label: t('common.search.item'),
    options: {
      customBodyRender: (_: any, column: DataTableMeta) => {
        const item = data[column.rowIndex];
        return <ItemColumn item={item} />;
      },
    },
  },
  {
    name: 'highlight',
    label: t('common.search.columns.highlight'),
    options: {
      customBodyRender: (_: any, column: DataTableMeta) => {
        const item = data[column.rowIndex];

        return <HighlightColumn t={t} item={item} />;
      },
    },
  },
  {
    name: 'type',
    label: t('common.search.columns.type'),
    options: {
      customBodyRender: (type: SearchType) => {
        return <TypeColumn type={type} />;
      },
    },
  },
  {
    name: 'link',
    label: t('common.search.columns.link'),
    options: {
      customBodyRender: (_: any, column: DataTableMeta) => {
        const item = data[column.rowIndex];

        return <LinkColumn item={item} />;
      },
    },
  },
];
